import { render, staticRenderFns } from "./PasswordExpiredModal.html?vue&type=template&id=01544bce&scoped=true&"
import script from "./PasswordExpiredModal.vue?vue&type=script&lang=ts&"
export * from "./PasswordExpiredModal.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordExpiredModal.scss?vue&type=style&index=0&id=01544bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01544bce",
  null
  
)

export default component.exports